import {
  START_LOADING,
  END_LOADING,
  FETCH_COST_CENTERS,
  FETCH_COST_CENTER,
  ADD_COST_CENTER,
  UPDATE_COST_CENTER,
  DELETE_COST_CENTER,
  COST_CENTERS_ERROR,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  costCenters: [],
  costcenters: [],   // compat: Invoice, Purchase, Transaction read this key
  costCenter: null,
  costcentersById: null, // compat: Transaction reads this key
  error: null,
};

const costCenters = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true, error: null };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_COST_CENTERS:
      return { ...state, costCenters: action.payload.data, costcenters: action.payload.data, error: null };
    case FETCH_COST_CENTER:
      return { ...state, costCenter: action.payload, costcentersById: action.payload, error: null };
    case ADD_COST_CENTER:
      return { ...state, costCenters: [...state.costCenters, action.payload], error: null };
    case UPDATE_COST_CENTER:
      return {
        ...state,
        costCenters: state.costCenters.map((c) =>
          c._id === action.payload._id ? action.payload : c
        ),
        error: null,
      };
    case DELETE_COST_CENTER:
      return {
        ...state,
        costCenters: state.costCenters.filter((c) => c._id !== action.payload),
        error: null,
      };
    case COST_CENTERS_ERROR:
      return { ...state, error: action.payload };
    default:
      return state;
  }
};

export default costCenters;
